// extracted by mini-css-extract-plugin
export var container = "_6q-0";
export var infoButton = "_6q-1";
export var label = "_6q-3";
export var labelExpanded = "_6q-4";
export var price = "_6q-5";
export var priceExpanded = "_6q-6";
export var title = "_6q-2";